export default __webpack_public_path__ + "static/media/PTQ.8ccc8af4.jpg";